<template>
  <div class="text-right">
    <form method="get" action="/search" autocomplete="off" class="flex mx-auto">
      <label class="search" for="search" :class="{ active: searchFocused }">
        <input id="search" name="q" type="text" ref="search" placeholder="Search Whittaker" v-model="query"/>
        <div class="close" :class="{ active: query && searchFocused  }" @click.prevent="clear"></div>
      </label>
      <button type="submit" class="search-submit"></button>
    </form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      query: "",
      searchFocused: true
    }
  },
  props: {
    searchQuery: ""
  },
  methods: {
    clear() {
      this.query = "";
    }
  },
  mounted() {
    this.query = this.searchQuery;
  }
}
</script>
<style lang="scss" scoped>

$icn-color: #00294D;
$text-color: #00294D;

.search-submit {
  width: 35px;
  height: 35px;
  border-radius: 20px;
  margin-left: 5px;
  background: $icn-color url('/img/search.svg') no-repeat center;
  background-size: 20px;

  &:focus {
    outline:none;
  }
}

.search {
  display: inline-block;
  position: relative;
  height: 20px;
  width: 20px;
  box-sizing: border-box;
  border: 2px solid $icn-color;
  border-radius: 20px;
  transition: all 200ms ease;
  cursor: text;

  &:after {
    content: "";
    position: absolute;
    width: 2px;
    height: 10px;
    right: -3px;
    top: 14px;
    background: $icn-color;
    border-radius: 3px;
    transform: rotate(-45deg);
    transition: all 200ms ease;
  }

  &.active,
  &:hover {
    width: 200px;
    height: 35px;
    margin-right: 0px;

    &:after {
      height: 0px;
    }
  }

  input {
    width: 100%;
    border: none;
    box-sizing: border-box;
    font-size: 15px;
    background: transparent;
    outline-width: 0;

    padding: 0 10px;
    margin: 6px 0;
    color: $text-color;
  }

  .close {

    cursor: pointer;

    &.active {
      opacity: 1;
    }

    opacity: 0;
    transition: opacity 0.3s ease;

    width: 20px;
    height: 20px;
    border-radius: 99px;
    background-color: #fff;

    position: absolute;
    right: 6px;
    top: 50%;
    transform: translateY(-50%);

    &:before, &:after {
      position: absolute;
      top: 4px;
      left: 9px;
      content: ' ';
      height: 12px;
      width: 2px;
      background-color: $icn-color;
    }

    &:before {
      transform: rotate(45deg);
    }

    &:after {
      transform: rotate(-45deg);
    }
  }
}

</style>